var map = {
	"./buoyant.svg": "75d9",
	"./coriolis.svg": "dc7f",
	"./friction.svg": "3ebd",
	"./normal.svg": "53d2",
	"./notAllowed.svg": "82df",
	"./rope.svg": "7c8d",
	"./spring.svg": "0ac0",
	"./weight.svg": "52eb",
	"./xAxis.svg": "04ff",
	"./yAxis.svg": "372a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6046";